<template>
  <v-form ref="form">
    <v-row>
      <v-col cols="6" class="pb-0">
        <AutocompleteAcaPeriod
          dense
          outlined
          return-object
          label="Khóa"
          v-model="academicPeriod"
          @change="academicPeriodChanged"
          required
          :rules="[$rules.required]"
          class="required"
        />
      </v-col>
      <v-col cols="6" class="pb-0">
        <AutocompleteClass
          v-model="classData"
          label="Lớp"
          outlined
          dense
          :type="'administrative'"
          :filter="classFilter"
          required
          @change="classChanged"
          class="required"
          :rules="[$rules.required]"
        />
      </v-col>
      <v-col v-if="showTeacher === true" cols="6" class="pt-0">
        <AutocompleteTeacherCard
          v-model="teacher"
          clear-icon="mdi-close"
          label="Giáo viên"
          outlined
          dense
          deletable-chips
          required
          class="required"
          :rules="[$rules.required, ...rules]"
        />
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import AutocompleteSubject from '@/components/basic/input/AutocompleteSubject'
import AutocompleteClass from '@/components/basic/input/AutocompleteClass'
import AutocompleteTeacherCard from '@/components/basic/input/AutocompleteTeacherCard'
import get from 'lodash-es/get'
import { mapActions } from 'vuex'
import AutocompleteAcaPeriod from '../input/AutocompleteAcaPeriod.vue'

export default {
  components: {
    AutocompleteSubject,
    AutocompleteAcaPeriod,
    AutocompleteClass,
    AutocompleteTeacherCard,
  },
  props: {
    state: Boolean,
    showTeacher: Boolean,
  },
  data() {
    return {
      academicPeriod: null,
      classData: null,
      teacher: null,
      subject: null,
      teachings: null,
      rules: [
        (value) => {
          if (!this.teachings || !this.subject || !value || !this.classData) return true
          const subjectId = this.subject.id
          const classId = this.classData.id
          return (
            !this.teachings.find(
              (m) => m.teacher && m.teacher.id === value.id && m.subject.id === subjectId && m.class.id === classId
            ) || 'Giáo viên này đã được phân công vào lớp trên'
          )
        },
      ],
    }
  },
  computed: {
    classFilter() {
      return { academicPeriod: get(this.academicPeriod, 'id'), type: 'coreCurriculum', division_null: false }
    },
  },
  methods: {
    classChanged(classData) {
      if (
        this.subject &&
        classData &&
        (classData.academicPeriod.id !== this.subject.academicPeriod.id ||
          get(classData, 'division.id') !== get(this.subject, 'division.id'))
      ) {
        this.subject = null
      }
      this.academicPeriod = get(classData, 'academicPeriod')
    },
    academicPeriodChanged(academicPeriod) {
      if (this.classData && academicPeriod && this.classData.academicPeriod !== academicPeriod) {
        this.classData = null
      }
      if (this.subject && academicPeriod && this.subject.subjectGroup.academicPeriod !== academicPeriod) {
        this.subject = null
      }
      this.academicPeriod = academicPeriod
    },
    ...mapActions('teaching', ['fetchTeachings']),
    getData() {
      if (this.$refs.form.validate()) {
        return {
          class: this.classData,
          academicPeriod: this.academicPeriod,
          teacher: this.teacher,
        }
      }
      return null
    },
    resetData() {
      this.academicPeriod = null
      this.classData = null
      this.teacher = null
      this.subjectGroup = null
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
  },
  mounted() {
    this.$refs.form.reset()
  },
  async created() {
    this.teachings = await this.fetchTeachings()
  },
  watch: {
    async state(state) {
      if (!state) {
        this.resetData()
        this.$refs.form.reset()
      } else {
        this.teachings = await this.fetchTeachings()
      }
    },
    classData: 'resetValidation',
    academicPeriod: 'resetValidation',
    subject: 'resetValidation',
  },
}
</script>
